import React from 'react'
import Listas from './Listas'
import {
    makeStyles,
    Drawer,
    Divider,
} from '@material-ui/core'

const estilos = makeStyles(theme => ({
    drawer: {
        display: 'flex',
        width: 250,
        flexShrink: 1,
    },
    drawerPaper: {
        display: 'flex',
        backgroundColor: 'black',
    },
   
 
}))

const Cajon = (props) => {

    const classes = estilos()

    return (
        
        <Drawer
            className={classes.drawer}  
            classes={{
                paper: classes.drawerPaper
            }}
          
              
            anchor="left"
            variant={props.variant}
            open={props.open}
            onClose={props.onClose ? props.onClose : null}
        >
            <div className={classes.toolbar}></div>
            <Divider />
            <Listas />
         
        </Drawer>
    )
}

export default Cajon;
